import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["plugin_invocations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isAgentResponse } from '../types';

// ****************************************************************************
// Getters and Setters
// ****************************************************************************

export var getId = function getId(streamResponse) {
  return streamResponse.message.message.id;
};
var updatePluginInvocationAssistantMessage = function updatePluginInvocationAssistantMessage(response, streamPluginInvocation) {
  var pluginInvocation = streamPluginInvocation.message;
  var pluginInvocationMessage = _objectSpread({
    message_id: response.id
  }, pluginInvocation);
  var updatedMessage = _objectSpread({}, response);
  var updatedPluginInvocations = _toConsumableArray(updatedMessage.plugin_invocations);
  var currentIndex = updatedPluginInvocations.findIndex(function (pi) {
    return pi.plugin_name === pluginInvocationMessage.plugin_name;
  });
  if (currentIndex === -1) {
    updatedPluginInvocations.push(pluginInvocationMessage);
  } else {
    updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
  }
  updatedMessage.plugin_invocations = updatedPluginInvocations;
  return updatedMessage;
};
var updatePluginInvocationAgentResponse = function updatePluginInvocationAgentResponse(response, streamPluginInvocation) {
  return _objectSpread(_objectSpread({}, response), {}, {
    message: updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
  });
};
export var updatePluginInvocation = function updatePluginInvocation(response, streamPluginInvocation) {
  return _objectSpread(_objectSpread({}, response), {}, {
    message: updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
  });
};
var addAnswerPartAssistantMessage = function addAnswerPartAssistantMessage(response, answerPart) {
  var content = "".concat(response.content).concat(answerPart.message.content);

  // Remove source indexes, e.g [^1^] from the content
  var cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
  return _objectSpread(_objectSpread({}, response), {}, {
    content: cleanedContent
  });
};
var addAnswerPartAgentResponse = function addAnswerPartAgentResponse(response, answerPart) {
  return _objectSpread(_objectSpread({}, response), {}, {
    message: addAnswerPartAssistantMessage(response.message, answerPart)
  });
};
export var addAnswerPart = function addAnswerPart(response, answerPart) {
  return _objectSpread(_objectSpread({}, response), {}, {
    message: addAnswerPartAgentResponse(response.message, answerPart)
  });
};
var removeSensitiveDataAssistantMessage = function removeSensitiveDataAssistantMessage(message) {
  var plugin_invocations = message.plugin_invocations,
    rest = _objectWithoutProperties(message, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    plugin_invocations: plugin_invocations.map(function (pluginInvocation) {
      return _objectSpread(_objectSpread({}, pluginInvocation), {}, {
        plugin_output: '--PRIVATE--'
      });
    })
  });
};
var removeSensitiveDataAgentResponse = function removeSensitiveDataAgentResponse(message) {
  return _objectSpread(_objectSpread({}, message), {}, {
    message: removeSensitiveDataAssistantMessage(message.message)
  });
};
export var removeSensitiveData = function removeSensitiveData(message) {
  return _objectSpread(_objectSpread({}, message), {}, {
    message: removeSensitiveDataAgentResponse(message.message)
  });
};

// ****************************************************************************
// Constructors
// ****************************************************************************

export var createHumanMessage = function createHumanMessage(id, content, isFromSeededConversation, requestId) {
  return {
    role: 'HUMAN',
    id: id,
    content: content,
    time_created: new Date().toISOString(),
    user_ari: 'unknown',
    plugin_invocations: [],
    isFromSeededConversation: isFromSeededConversation,
    requestId: requestId
  };
};
export var toStreamResponse = function toStreamResponse(message) {
  if (isAgentResponse(message)) {
    return {
      type: 'FINAL_RESPONSE',
      message: message
    };
  }
  return {
    type: 'FINAL_RESPONSE',
    message: {
      message: message
    }
  };
};
export var createEmptyFeatures = function createEmptyFeatures() {
  return {
    account_id: '',
    cloud_id: '',
    env: '',
    env_type: '',
    model: '',
    ai_enabled_on_site: false,
    assistance_feature_enabled: false,
    debug_enabled: false
  };
};